import React from 'react'

import { richTextStyle } from 'utils/richTextHelpers'
import letterSpacingFor from 'utils/letterSpacingFor'
import type { RichTextElementState } from 'EditorApp/types'
import { legacyLineHeightFor } from 'utils/lineHeightFor'

interface Props {
  children: React.ReactNode
  element: RichTextElementState
  fontFamily: string
  isActive: boolean
}

const RichTextElement = ({
  children,
  element,
  fontFamily,
  isActive,
}: Props) => {
  const letterSpacing = letterSpacingFor(element.fontSize)
  const textTransform =
    element.textCapitalisation == 'lower' ? 'lowercase' : 'none'

  // Old RichText elements which aren't yet converted to SVG need the line
  // height set on the container here. Newer ones will set a line height on
  // each H2, P, etc. to override this.
  const lineHeight = legacyLineHeightFor(element.fontSize)

  const style = {
    color: element.color,
    fontFamily,
    fontKerning: 'normal',
    fontSize: element.fontSize,
    height: element.height,
    lineHeight: `${lineHeight}px`,
    letterSpacing: `${letterSpacing}em`,
    textAlign: element.textAlign,
    textTransform: textTransform,
    width: element.width,
    '--marker-color': element.markerColor,
    '--anchor-color': element.anchorColor,
  }

  return (
    <div
      className="RichTextElement"
      // @ts-expect-error fontKerning and textTransform are fine, but causing
      // an error with Typescript.
      style={style}
      data-element-id={element.id}
    >
      {isActive ? (
        children
      ) : (
        <div
          className="RichText"
          dangerouslySetInnerHTML={{
            __html: element.renderedSvg ?? element.body,
          }}
          style={richTextStyle(element)}
        />
      )}
    </div>
  )
}

export default RichTextElement
